<template>
  <div>
    <el-dialog title="导出对账单" center :visible.sync="exportFormVisible" width="600px">
      <el-form :model="exportForm" ref="editForm">
        <el-form-item label="日期范围：" :label-width="formLabelWidth">
          <el-date-picker v-model="exportForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportFormVisible = false">取 消</el-button>
        <el-button @click="submitExport">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="TC_NAME" label="公司名称"></el-table-column>
          <el-table-column prop="MONTH" label="月份"></el-table-column>
          <el-table-column prop="REAL_ORDER_COUNT" label="订单数量"></el-table-column>
          <el-table-column prop="REAL_ORDER_FEE" label="结算金额"></el-table-column>
          <el-table-column prop="STATUS" label="状态"></el-table-column>
          <el-table-column fixed="right" label="操作" width="320">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-download" @click="exportOrder(scope.row)">导出</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="invoiceDetail(scope.row)">开票明细</el-button>
              <el-button type="text" size="small" icon="el-icon-download" @click="monthlyIncome(scope.row)">月收入
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  tcOrderFun,
  //  tcName,
  exportMonthFun, exportSettlementFun, exportOrder,
} from 'api/tcBanlance';
import http from '@/assets/common/http';

export default {
  props: {
    searchForm1: {
      type: Object,
      default: null,
    },
    currentPage1: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      exportForm: {},
      formLabelWidth: '100px',
      exportFormVisible: false,
      tableData: [],
      searchForm: this.searchForm1,
      tcName: [],
      currentPage: this.currentPage1,
      totalCount: 0,
      pageSize: 10,
      loading: false,
    };
  },
  // created() {
  mounted() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.ORDER_LIST_SEARCH_CONDITION.CONDITION) {
    //   this.searchForm = this.ORDER_LIST_SEARCH_CONDITION.CONDITION;
    //   // this.currentPage = this.ORDER_LIST_SEARCH_CONDITION.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
    // this.queryData();
    // this.queryTCName();
  },
  // computed: {
  //   ORDER_LIST_SEARCH_CONDITION() {
  //     return this.$store.state.ORDER_LIST_SEARCH_CONDITION;
  //   },
  // },
  methods: {
    submitExport() {
      const params = {
      };
      if (this.exportForm.DAY_INTERVAL) {
        params.START_DAY = this.exportForm.DAY_INTERVAL[0];
        params.END_DAY = this.exportForm.DAY_INTERVAL[1];
      }
      exportOrder(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.exportFormVisible = false;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    exportDoc() {
      this.exportFormVisible = true;
    },
    // ----------------------------分页
    handleCurrentChange(e) {
      this.queryData();
    },
    // ---------------------------------------------结算明细
    lookReduce() {
      this.$router.push({ name: 'tcBillingDetails' });
    },
    // ---------------------------------------------导出
    exportOrder(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: Number(row.TC_ID),
            MONTH: row.MONTH,
          };
          exportSettlementFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ---------------------------------------------开票明细
    invoiceDetail(row) {
      this.$router.push({ name: 'tcInvoiceDetail' });
      sessionStorage.setItem('TC_ID', row.TC_ID);
      sessionStorage.setItem('MONTH', row.MONTH);
    },
    // ---------------------------------------------月收入
    monthlyIncome(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: Number(row.TC_ID),
            MONTH: row.MONTH,
          };
          exportMonthFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // --------------------------------搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryData();
    },
    // ---------------------------------拉取团餐公司列表
    queryData() {
      const params = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.tc_name) {
        params.TC_ID = this.searchForm.tc_name;
      }
      if (this.searchForm.MONTH) {
        params.MONTH = this.searchForm.MONTH;
      }
      this.loading = true;
      tcOrderFun(params).then((result) => {
        this.$store.dispatch('SET_ORDER_LIST_SEARCH_CONDITION', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
        if (result.length != 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.tableData.forEach((element) => { // tableData你的数据源
            switch (element.STATUS) {
              case 1:
                element.STATUS = '未开始结算';
                break;
              case 2:
                element.STATUS = '开始结算';
                break;
              case 3:
                element.STATUS = '已开发票';
                break;
              case 4:
                element.STATUS = '发票已收';
                break;
              case 5:
                element.STATUS = '款已付';
                break;
              default:
                element.STATUS = '状态未翻译';
            }
          });
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    detail(row) {
      this.$router.push({ path: '/tcOrderList/detail' });
      sessionStorage.setItem('ID', row.TC_ID);
      sessionStorage.setItem('MONTH', row.MONTH);
      sessionStorage.setItem('COST', row.REAL_ORDER_FEE);
      sessionStorage.setItem('tcStatus', row.STATUS);
      sessionStorage.setItem('balanceId', row.BALANCE_ID);
      sessionStorage.setItem('orderCount', row.REAL_ORDER_COUNT);
    },
    // --------------------------------------------获取团餐公司名称
    async queryTCName() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 17,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      // tcName()
      await http.post(params).then((result) => {
        if (result[0].length !== 0) {
          this.tcName = result.length > 0 ? result : [];
          this.$emit('tcNameChange', this.tcName);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 日结算数据导出
    exportData() {
      const params = {
        SERVICE_ID: '10011',
        OTYPE: 8,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.tc_name) {
        params.TC_ID = this.searchForm.tc_name;
      }
      if (this.searchForm.MONTH) {
        params.MONTH = this.searchForm.MONTH;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/TCBalanceList.vue